import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const cardUnlinkOutflowWeb = isFeature('card-unlink-outflow-web');
export const cardUnlinkOutflowTouch = isFeature('card-unlink-outflow-touch');
